import React, { useEffect, useRef, useState, } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import {
  SActionBtn,
  SLowcodeList,
  SDrawer,
  STableActions,
  SMessage,
} from 'shj-components'
import config from './config';
import { AddOrEditForm } from './components/addOrEdit'
import dayjs from 'dayjs'
import {message} from 'antd'
import {orderInvoiceList, orderInvoiceSaveOrUpdate, orderInvoiceDelete} from '@/services/fmsServices'
export default function PaymentServiceManage(props) {
  const history = useNavigate();
  const [openModal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editData, setEditData] = useState(null);
  const listRef = useRef<any>();
  const { id } = props
  useEffect(() => {
    reloadFn()
  }, [id])
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        query.orderAccountId = id
        orderInvoiceList(current, pageSize, query).then((res)=>{
          resolve(res)
        })
      } catch (e) {
        reject({ success: false });
      }
    });
  };
// 刷新
const reloadFn = () => {
  const {
    current: { reload },
  } = listRef;
  reload();
};
  // 右侧表格事件：
  const onAdd = () => {
    setEditData(null)
    setModal(true)
  }
  const onEdit = (record: any) => {
    setEditData(record)
    // setReadOnly(true)
    setModal(true)
  }

  const onSave = (value: any) => {
    const formatDate = (date: any) => date ? dayjs(date).format('YYYY-MM-DD HH:mm:ss') : undefined;
    value.invoiceIssuanceDate = formatDate(value.invoiceIssuanceDate);
    value.orderAccountId = id
    if(value.filefUrl  && value.filefUrl[0]?.response){
      value.filefUrl = value.filefUrl[0].response.data.filePath
    }else{
      value.filefUrl = value.filefUrl[0].filefUrl
    }
    setLoading(true)
    orderInvoiceSaveOrUpdate(value).then((res)=>{
      message.success(res.message || '操作成功')
      reloadFn()
      setLoading(false)
      setModal(false)
    }).catch(err=>{
      setLoading(false)
    })
  }
  const onDel = (value: any) => {
    let dialog = SMessage.delete({
      onOk: () => {
        orderInvoiceDelete({id: value.id}).then((res)=>{
          message.success(res.message || '删除成功')
          reloadFn()
        })
        dialog?.destroy();
      },
      onCancel: () => {
        dialog?.destroy();
      },
    });
  }
  const getStatusOptions = () => {
    return new Promise(async resolve => {
      resolve({})
    })
  }

  // 右侧表格配置
  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onAdd },
    customRender: {
      renderOperate(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn auth="InvoiceRegistrationEdit" onClick={() => onEdit(record)}>编辑</SActionBtn>
            <SActionBtn auth="InvoiceRegistrationDel" danger onClick={() => onDel(record)}>
              删除
            </SActionBtn>
          </STableActions>
        )
      },
      taxRateCodeOperate(text){
        return (text + '%')
      },
      excludeTaxAmountOperate(text, record){
        return parseFloat((record.amount - record.taxAmount).toFixed(2)) || 0
      },
    },
  }
  return (
    <div>
      <SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" />
      {/* 新增弹出抽屉层 */}
      {/* 线下收款 */}
      <SDrawer
        title={editData?'编辑':'新增'}
        width="50%"
        okText="保存"
        isHideResetBtn={false}
        open={openModal}
        onClose={() => setModal(false)}
        destroyOnClose
        onSubmit={onSave}
        loading={loading}
        // maskClosable={false}
      >
        <AddOrEditForm editData={editData} />
      </SDrawer>
    </div>
  )
}